export const TIMESHEET_LOAD_REQUESTED = 'TIMESHEET_LOAD_REQUESTED';
export const TIMESHEET_LOAD_SUCCEEDED = 'TIMESHEET_LOAD_SUCCEEDED';
export const TIMESHEET_LOAD_FAILED = 'TIMESHEET_LOAD_FAILED';
export const TIMESHEET_LOAD_CANCELED = 'TIMESHEET_LOAD_CANCELED';

export const TIMESHEET_CREATE_REQUESTED = 'TIMESHEET_CREATE_REQUESTED';
export const TIMESHEET_CREATE_SUCCEEDED = 'TIMESHEET_CREATE_SUCCEEDED';
export const TIMESHEET_CREATE_FAILED = 'TIMESHEET_CREATE_FAILED';

export const TIMESHEET_UPDATE_REQUESTED = 'TIMESHEET_UPDATE_REQUESTED';
export const TIMESHEET_UPDATE_SUCCEEDED = 'TIMESHEET_UPDATE_SUCCEEDED';
export const TIMESHEET_UPDATE_FAILED = 'TIMESHEET_UPDATE_FAILED';

export const TIMESHEET_SET = 'TIMESHEET_SET';
